import { useSelector } from 'react-redux';

import { useAppDispatch } from 'src/store';
import { actions, selectors } from '../rentVerificationSlice';

const useSetRentVerification = () => {
  const dispatch = useAppDispatch();
  const filters = useSelector(selectors).filters;

  const filtering = (filter?: string) => {
    dispatch(actions.filtering({ filter, page: 0, rowsPerPage: filters?.rowsPerPage }));
  };

  const sorting = (sort?: string) => {
    dispatch(actions.sorting({ sort, page: 0, rowsPerPage: filters?.rowsPerPage }));
  };

  const searching = (q?: string) => {
    dispatch(actions.search({ q, page: 0, rowsPerPage: filters?.rowsPerPage }));
  };

  const paginating = (page: number, rowsPerPage: number) => {
    dispatch(actions.pagination({ page, rowsPerPage }));
  };

  const clearSearch = () => {
    dispatch(actions.clearSearch());
  };

  const clearAllFilters = () => {
    dispatch(actions.clearAllFilters());
  };

  return {
    filtering,
    sorting,
    searching,
    paginating,
    clearSearch,
    clearAllFilters
  };
};

export default useSetRentVerification;
